import seoData from "./seo-data.json";

export const ROUTE_SEO = seoData;
export const HOME_SEO = seoData["/"];
export const PRERENDER_ROUTES = Object.keys(seoData);
